var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecondMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1544 4.32C11.0725 3.32313 9.67124 2.66813 8.12374 2.52813L9.37499 0H14.2919L12.1544 4.32ZM13.125 9.375C13.125 12.4769 10.6012 15 7.49999 15C4.39874 15 1.87499 12.4769 1.87499 9.375C1.87499 6.27313 4.39874 3.75 7.49999 3.75C10.6012 3.75 13.125 6.27313 13.125 9.375ZM7.45499 10.625C7.53686 10.5688 7.62311 10.5119 7.70999 10.4544C8.41249 9.99062 9.37499 9.35437 9.37499 8.125C9.37499 7.09125 8.53374 6.25 7.49999 6.25C6.46624 6.25 5.62499 7.09125 5.62499 8.125H6.87499C6.87499 7.78 7.15499 7.5 7.49999 7.5C7.84499 7.5 8.12499 7.78 8.12499 8.125C8.12499 8.64437 7.70811 8.9575 7.02061 9.41187C6.36624 9.84375 5.62499 10.3344 5.62499 11.25V11.875H9.37499V10.625H7.45499ZM6.87249 2.52875L5.62499 0H0.642487L2.79624 4.36562C3.88374 3.34375 5.30249 2.67188 6.87249 2.52875Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_1451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondMedal);
export default __webpack_public_path__ + "static/media/SecondMedal.c593b25b953950af2c0eec4a1a3f8aeb.svg";
export { ForwardRef as ReactComponent };